const HightLights = ({ value }) => {
  return <div dangerouslySetInnerHTML={{ __html: value }}></div>;
};

export default HightLights;
